import { useRouter } from '@tanstack/react-router'
import { assetPath } from '@/utils/assetPath'
import { classNames } from '@/utils/classNames'

interface PageHeaderProps {
    title: string
    showBackButton?: boolean
    showRightButton?: boolean
    rightButton?: React.ReactNode
    className?: string
    onBack?: () => void
}

const PageHeader = ({
    title,
    showBackButton = true,
    showRightButton = false,
    rightButton,
    className,
    onBack,
}: PageHeaderProps) => {
    const router = useRouter()

    const handleBack = () => {
        if (onBack) {
            onBack()
        } else {
            router.history.go(-1)
        }
    }

    return (
        <div
            className={classNames(
                'sticky top-safe z-10 flex h-[52px] items-center justify-between px-2 py-4 md:top-0',
                className
            )}
        >
            {showBackButton ? (
                <button
                    onClick={handleBack}
                    className="h-6 w-6"
                    aria-label="Go back"
                >
                    <img src={assetPath('icons/arrow-left.svg')} alt="arrow-left" className="h-6 w-6" />
                </button>
            ) : (
                <div className="h-6 w-6" />
            )}
            <h4 className="text-18 font-semibold">{title}</h4>
            {showRightButton ? rightButton : <div className="h-6 w-6" />}
        </div>
    )
}

export default PageHeader
